module.exports = __webpack_public_path__ + "static/media/loading6.98395d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading6.png
// module id = 191
// module chunks = 0